const pkg = require('../../../../../package.json');

export const loadComponent = async (scope, module) => {
    // Initializes the share scope. This fills it with known provided modules from this build and all remotes
    await __webpack_init_sharing__('default');

    const container = window[scope]; // or get the container somewhere else
    // Initialize the container, it may provide shared modules
    await container?.init(__webpack_share_scopes__.default);
    const factory = await window[scope]?.get(module);
    const Module = factory?.();
    return Module;
};

export const getScript = async url => {
    const element = document.createElement('script');
    return new Promise((resolve, reject) => {
        element.src = url;
        element.type = 'text/javascript';
        element.async = true;
        element.onload = () => resolve(element);
        element.onerror = (_event, _source, _line, _col, error) => {
            // Remove the script tag if an error occurs
            document.head.removeChild(element);
            reject(error);
        };
        document.head.appendChild(element);
    });
};

const cache = {};
const versionRegex = /v\d+\.\d+\.\d+/;

export const getDynamicScript = async args => {
    let moduleReady = false;
    let scriptReady = false;
    let error;
    let ready = false;
    let module = undefined;
    let scriptElement = document.createElement('script');
    if (!args.url || moduleReady || module || scriptElement?.src) {
        return {ready: true, error, module};
    }

    const mfeVersion = pkg
        ? pkg.mfeDependencies[
            args.scope.replace(
                'rv_life_',
                ''
            )
            ]
        : '*';

    let url = args.url;
    const loadTaggedMfe = window.envObj['RVLIFE_MFE_USE_TAGGED_VERSION'] !== 'false';

    if (loadTaggedMfe) {
        url =
            mfeVersion === '*' ||
            mfeVersion === 'latest' ||
            versionRegex.test(args.url)
                ? args.url
                : args.url.replace(
                    '/remoteEntry.js',
                    `/v${mfeVersion}/remoteEntry.js`
                );
    }

    // Check if the script is already cached
    if (cache[url]) {
        module = cache[url];
        moduleReady = true;
        scriptReady = true;
        return {ready: true, error, module};
    }

    scriptReady = false;
    error = undefined;
    let retries = 4;
    let retry = 0;

    const makeRequestWithRetries = async (retryCount, baseDelay = 1000) => {
        try {
            retry++;
            const el = await getScript(url);
            scriptElement = el;
            scriptElement.src = url;
            document.head.appendChild(scriptElement);
            scriptReady = true;
        } catch (err) {
            if (retries <= 0) {
                error = err ? String(err) : `The script at ${url} failed to load.`;
            } else {
                const delay = 2 ** retry * baseDelay;
                retries--;
                // eslint-disable-next-line no-promise-executor-return
                await new Promise(resolve => setTimeout(resolve, delay));
                await makeRequestWithRetries(retryCount - 1, baseDelay);
            }
        }
    };

    await makeRequestWithRetries(retries);

    // Load component if script is ready and module is not yet loaded
    if (!moduleReady && scriptReady) {
        try {
            const loadedModule = await loadComponent(args.scope, args.module);
            module = loadedModule;
            cache[url] = loadedModule;
            moduleReady = true;
        } catch (err) {
            error = err ? String(err) : `Failed to load component ${args.module}.`;
        }
    }

    if (module && moduleReady && scriptReady) {
        ready = true;
    }

    return {ready, error, module};
};